<div [formGroup]="form">
  <h1 class="title">
    Votre expérience et documents
  </h1>
  <h5 class="title-text-muted text-muted fs-16">
    Ces informations nous permettront de mieux évaluer votre profil.
  </h5>

  <div class="mt-px-16">
    <app-custom-input 
      [parentForm]="form" 
      controlName="experience" 
      [label]="'Années d\'expérience'"
      [type]="'number'" 
      [required]="true" 
      [placeholder]="'0'">
    </app-custom-input>
  </div>

  <div class="mt-px-32">
    <h5 class="mb-px-16">Documents obligatoires</h5>
    <div class="row">
      <div class="col-6">
        <app-custom-dragdrop-image 
          text1="Carte d'identité" 
          text2="Recto/Verso" 
          text3="Déposez votre carte d'identité"
          [singleImage]="false" 
          
          [isDeletble]="true" 
          (sendImage)="getIdentityCard($event)">
        </app-custom-dragdrop-image>
      </div>
      <div class="col-6">
        <app-custom-dragdrop-image 
          text1="CV" 
          text2="Format PDF" 
          text3="Déposez votre CV"
          [singleImage]="true" 
          
          [isDeletble]="true" 
          (sendImage)="getCV($event)">
        </app-custom-dragdrop-image>
      </div>
    </div>
  </div>

  <div class="mt-px-32">
    <h5 class="mb-px-16">Documents complémentaires</h5>
    <div class="row">
      <div class="col-6">
        <app-custom-dragdrop-image 
          text1="Diplômes" 
          text2="Format PDF" 
          text3="Déposez vos diplômes"
          [singleImage]="false"  
          [isDeletble]="true" 
          (sendImage)="getDiplomas($event)">
        </app-custom-dragdrop-image>
      </div>
      <div class="col-6">
        <app-custom-dragdrop-image 
          text1="Certificats" 
          text2="Format PDF" 
          text3="Déposez vos certificats"
          [singleImage]="false"  
          [isDeletble]="true" 
          (sendImage)="getCertificates($event)">
        </app-custom-dragdrop-image>
      </div>
    </div>
  </div>

  <div class="mt-px-32">
    <app-custom-checkbox 
      [formGroup]="form" 
      controlName="acceptcgu" 
      [label]="'J\'accepte les conditions générales d\'utilisation'"
      required>
    </app-custom-checkbox>
  </div>
</div>
